import { MarketingDrawer } from '@app/components/general'
import { metaSetter } from '@app/utils'
import type { PageProps } from '@app/types'
import { Header } from '@app/components/general/header'
import { Link } from '@app/components/stateless/typo/link'
import { DivContainer } from '@app/components/stateless/containers/div-container'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import Trans from 'next-translate/Trans'
import loadNamespaces from 'next-translate/loadNamespaces'
import type { GetStaticProps } from 'next'
import { I18nDictionary } from 'next-translate'
import { companyName } from '@app/configs'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/roadmap',
    }),
  }
}

function RoadMap({ name }: PageProps) {
  const { t } = useTranslation('roadmap')

  return (
    <MarketingDrawer title={name}>
      <DivContainer className='space-y-4'>
        <div>
          <Header>{t('header')}</Header>
          <Trans
            i18nKey='roadmap:subtitle'
            values={{ companyName: companyName }}
            components={[
              <Paragraph key={'p-1'} />,
              <Link
                href='/changelog'
                className='text-blue-600 dark:text-blue-500 hover:text-blue-800 underline'
                key={'a-1'}
              />,
            ]}
          />
        </div>

        <div>
          <h2 className='text-xl font-semibold'>{t('goals')}</h2>
          <Paragraph>{t('goals-details')}</Paragraph>
        </div>

        <div>
          <h3 className='text-xl font-semibold'>{t('dev')}</h3>
          <Trans
            i18nKey='roadmap:dev-details'
            components={[
              <Paragraph key={'p-2'} />,
              <a
                href='https://github.com/a11ywatch'
                className='underline text-blue-600 dark:text-blue-500 hover:text-blue-800'
                target={'_blank'}
                rel='noreferrer'
                key={'a-2'}
              />,
            ]}
          />
        </div>
      </DivContainer>
    </MarketingDrawer>
  )
}

export default metaSetter(
  { RoadMap },
  {
    translation: 'roadmap',
  }
)
